export default {"src":"/_next/static/media/Parkinsons Disease.c5d130c7.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};